/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Signup_Checkout_Failed_ToastInputs */

const en_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to start checkout: ${i?.message}`)
};

const fr_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du demarrage du paiement : ${i?.message}`)
};

const de_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start des Bezahlvorgangs fehlgeschlagen: ${i?.message}`)
};

const it_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile avviare il checkout: ${i?.message}`)
};

const ru_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось начать оформление заказа: ${i?.message}`)
};

const es_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al iniciar el pago: ${i?.message}`)
};

const zh_cn2_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`结账失败：${i?.message}`)
};

const ja_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チェックアウトを開始できませんでした: ${i?.message}`)
};

const hi_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चेकआउट शुरू करने में विफल: ${i?.message}`)
};

const pt_pt2_signup_checkout_failed_toast = /** @type {(inputs: Signup_Checkout_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao iniciar o checkout: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to start checkout: {message}" |
*
* @param {Signup_Checkout_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_checkout_failed_toast = /** @type {((inputs: Signup_Checkout_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Checkout_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_checkout_failed_toast(inputs)
	if (locale === "de") return de_signup_checkout_failed_toast(inputs)
	if (locale === "it") return it_signup_checkout_failed_toast(inputs)
	if (locale === "ru") return ru_signup_checkout_failed_toast(inputs)
	if (locale === "es") return es_signup_checkout_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_checkout_failed_toast(inputs)
	if (locale === "ja") return ja_signup_checkout_failed_toast(inputs)
	if (locale === "hi") return hi_signup_checkout_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_checkout_failed_toast(inputs)
	return en_signup_checkout_failed_toast(inputs)
});